"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrushEndProvided = exports.isBrushAvailableSelector = void 0;
var create_selector_1 = require("../../../../state/create_selector");
var get_heatmap_config_1 = require("./get_heatmap_config");
exports.isBrushAvailableSelector = create_selector_1.createCustomCachedSelector([get_heatmap_config_1.getHeatmapConfigSelector], function (config) {
    return Boolean(config.onBrushEnd) && config.brushTool.visible;
});
exports.isBrushEndProvided = create_selector_1.createCustomCachedSelector([get_heatmap_config_1.getHeatmapConfigSelector], function (config) {
    return Boolean(config.onBrushEnd);
});
//# sourceMappingURL=is_brush_available.js.map